import { Box, Typography, Divider, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CheckIcon from '@mui/icons-material/Check'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import IssueLayer from './IssueLayer'
import { sortIssues } from '../../../../utils/sortIssues'

const PageBlocks = ({
  page,
  fullPageBlock,
  pageBlocks,
  selectedSection,
  setSelectedSection,
  selectedIssue,
  setSelectedIssue,
  handleBlockModalOpen
}) => {
  const handleSectionClick = (block) => {
    setSelectedSection(block)
    if (block.Issues.length) {
      setSelectedIssue(sortIssues(block.Issues)[0])
    } else {
      setSelectedIssue(null)
    }
  }

  const handleIssueClick = (issue) => setSelectedIssue(issue)

  return (
    <Box className="uiTestingTabPageBlocksContainer">
      <Box className="pageBlocksSectionsContainer">
        <Typography className="pageBlocksSectionsTitle">Sections</Typography>
        <Box className="pageBlocksSectionsContent">
          { pageBlocks.length > 1
            ? <Box
                key={fullPageBlock.id}
                className="pageBlocksSectionsContentItem"
                onClick={() => handleSectionClick(fullPageBlock)}
                sx={{ backgroundColor: selectedSection?.id === fullPageBlock.id ? 'primary.medium' : 'transparent' }}
              >
                Full page
              </Box>
            : null
          }
          { pageBlocks.map((block, index) => (
              <Box
                key={block.id}
                className="pageBlocksSectionsContentItem"
                onClick={() => handleSectionClick(block)}
                sx={{ backgroundColor: selectedSection?.id === block.id ? 'primary.medium' : 'transparent' }}
              >
                {block.name ? block.name : `Scroll ${index+1}`}
                { block.Issues.length
                  ? <span className="pageBlocksSectionsContentItemTotal">{block.Issues.length}</span>
                  : <CheckIcon color='success'/>}
              </Box>
            ))
          }
        </Box>
      </Box>
      <Divider className="pageBlocksSectionsDivider" orientation="vertical" flexItem />
      <Box className="pageBlocksPreviewContainer">
        <Typography className="pageBlocksPreviewTitle">Preview</Typography>
        { selectedSection?.img_storage_link ?
          <Box className="pageBlocksPreviewContentContainer">
            <Box className="pageBlocksPreviewContent" onClick={handleBlockModalOpen}>
              <img
                className="pageBlocksPreviewContentImage"
                src={selectedSection?.img_storage_link}
                alt="Block Screenshot"
              />
              {selectedIssue &&
                <IssueLayer
                  top={selectedIssue.b_box_relative_top}
                  right={selectedIssue.b_box_relative_right}
                  bottom={selectedIssue.b_box_relative_bottom}
                  left={selectedIssue.b_box_relative_left}
                />
              }
            </Box>
            <Box className="pageBlocksPreviewZoomIconButtonContainer">
              <Box className="pageBlocksPreviewZoomIconButton" onClick={handleBlockModalOpen}>
                <ZoomInIcon color='secondary'/>
              </Box>
            </Box>
          </Box> : null
        }
      </Box>
      <Divider className="pageBlocksSectionsDivider" orientation="vertical" flexItem />
      <Box className="pageBlocksIssuesContainer">
        <Typography className="pageBlocksIssuesTitle">Issues</Typography>
        <Box className="pageBlocksIssuesContent">
          { selectedSection.Issues.length
            ? <>
              { selectedSection.Issues.map(
                (issue) =>
                  <Box
                    key={issue.id}
                    className="pageBlocksIssuesItem"
                    onClick={() => handleIssueClick(issue)}
                    sx={{ backgroundColor: selectedIssue === issue ? 'primary.medium' : 'transparent' }}
                  >
                    <span>{issue.type}</span>
                    <Box className="pageBlocksIssuesItemConfidenceContainer">
                      <span className="pageBlocksIssuesItemConfidenceValue">{Math.round(issue.confidence * 100)}%</span>
                      <Tooltip
                        className="pageBlocksIssuesItemConfidenceIcon"
                        title="Confidence"
                        PopperProps={{
                          sx: {
                            '& .MuiTooltip-tooltip': {
                              backgroundColor: 'primary.main'
                            },
                          },
                        }}
                      >
                        <InfoOutlinedIcon fontSize="small" color='primary'/>
                      </Tooltip>
                    </Box>
                  </Box>
              )}
            </>
            : selectedSection?.id === fullPageBlock.id
              ? page?.page.issue_count
                ? <Typography className="pageBlocksIssuesErrorMessage">
                  Issues were detected in scroll screenshots. Select a section to view them.
                </Typography>
                : null
              : <Typography className="pageBlocksIssuesErrorMessage">
                No issues.
              </Typography>
          }
        </Box>
      </Box>
    </Box>
  )
}

export default PageBlocks